import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Footer from './footer';
import Header from './header';
import apiUrl from './base_url';
import '../components/cssfile/question_paper.css';
import '../components/cssfile/job.css';
import { FaArrowRight } from "react-icons/fa";

class Intrance extends React.Component {
  constructor() {
    super();
    this.state = {
      job: [],
      admit: [],
      result: [],
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    axios
      .get(apiUrl + 'serverside/latest_job.php')
      .then((response) => {
        this.setState({
          job: response.data.filter(item => item.category === 'notification' && item.exam_category === 'entrance'),
          admit: response.data.filter(item => item.category === 'admitcard' && item.exam_category === 'entrance'),
          result: response.data.filter(item => item.category === 'result' && item.exam_category === 'entrance'),
          loading: false,
        });
        console.log("ENTRANCE Job:", response.data.filter(item => item.category === 'notification' && item.exam_category === 'entrance'));
console.log("ENTRANCE Admit:", response.data.filter(item => item.category === 'admitcard' && item.exam_category === 'entrance'));
console.log("ENTRANCE Result:", response.data.filter(item => item.category === 'result' && item.exam_category === 'entrance'));

      })
      .catch((error) => {
        this.setState({ error: 'There was an error fetching the data!', loading: false });
        
      });
  }

  renderSection = (title, items, color) => (
    <div className="col-lg-4 col-md-6 mb-4">
      <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
        <div className="card-header text-white text-center" style={{ backgroundColor: color, fontSize: '18px', fontWeight: 'bold' }}>
          {title}
        </div>
        <div className="card-body p-4">
          {items.length > 0 ? (
            <ul className="list-unstyled">
              {items.slice(0, 10).map((item, index) => {
                const slug = item.topic_name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
                return (
                  <li key={index} className="mb-3 d-flex align-items-center">
                    <Link 
                      to={{ pathname: `/job_detail/${slug}`, state: { url: item.url, id: item.id } }}
                      className="job-link"
                    >
                      <FaArrowRight className="me-2 text-primary" /> {item.topic_name.slice(0, 60) + '...'}
                    </Link>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="text-center text-muted" style={{ fontSize: '14px' }}>No {title.toLowerCase()} available.</p>
          )}
        </div>
      </div>
    </div>
  );

  render() {
    const { job, admit, result, loading, error } = this.state;

    if (loading) return <div className="text-center mt-5">Loading...</div>;
    if (error) return <div className="text-center mt-5 text-danger">{error}</div>;

    return (
      <div style={{ backgroundColor: '#f8f9fa' }}>
        <Header />
        <div className="container mt-5">
          <h2 className="text-center mb-4 text-primary fw-bold">Latest Entrance Exam Updates</h2>
          <div className="row gy-4">
            {this.renderSection('Latest Entrance Exams', job, '#007bff')}
            {this.renderSection('Admit Cards', admit, '#17a2b8')}
            {this.renderSection('Results', result, '#28a745')}
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Intrance;
